module.exports = __webpack_public_path__ + "img/Slider1.753a3abd.svg";